const updateConsentBar = (element, callback) => {
    const maxWaitTime = 7000;
    const interval = 90;
    let elapsedTime = 0;

    const waitingInterval = setInterval(() => {
        const selector = document.querySelector(element);
        if (selector) {
            callback();
            clearInterval(waitingInterval);
        } else {
            elapsedTime += interval;
            if (elapsedTime >= maxWaitTime) {
                clearInterval(waitingInterval);
            }
        }
    }, interval);
};

updateConsentBar(".cookieconsent-wrapper", () => {
    const consentBar = document.querySelector(".cookieconsent-wrapper");
    consentBar.classList.add("consent-bar-consent-bar");

    const consentBarCont = consentBar.parentElement;
    consentBarCont.classList.add("consent-bar-consent-bar-cont");

    const consentBarText = consentBarCont.querySelector(".cc-message");
    consentBarText.classList.add("consent-bar-consent-bar-text");

    const consentBarReject = consentBarCont.querySelector(".isense-cc-deny");
    consentBarText.innerHTML = `
              <img class="consent-bar-icon" src="https://cdn.shopify.com/s/files/1/0261/6507/files/mingcute_cookie-fill.png?v=1742804294" alt="cookie" />
              <div class="RBR-bar-text">
                  <p> <span> Ripstop </span> uses <span><a target="blank" href="/pages/privacy-policy">cookies</a></span> to improve your experience 💚 </p>
                  <p> YOU ONLY HAVE TO DO THIS ONCE </p>
              </div>
          `;

    consentBarSettings = consentBarCont.querySelector(".isense-cc-settings");
    consentBarSettings.classList.add("consent-bar-consent-bar-settings");
    consentBarSettings.innerText = "";
    consentBarSettings.addEventListener("click", () => {
        consentBar.classList.add("consent-bar-hide");
    });

    const consentBarButtonsCont =
        consentBarCont.querySelector(".cc-compliance");
    consentBarButtonsCont.classList.add("consent-bar-consent-bar-buttons-cont");

    consentBarReject.classList.add("consent-bar-consent-bar-reject");
    const consentBarAccept = consentBarCont.querySelector(".isense-cc-allow");
    consentBarAccept.classList.add("consent-bar-consent-bar-accept");
    consentBarAccept.innerText = "";

    const consentView = document.querySelector(".cc-settings-view");
    consentView.classList.add("consent-bar-consent-view");

    const consentViewTitle = consentView.querySelector(
        ".isense-cookie-settings-header"
    );
    consentViewTitle.classList.add("consent-bar-consent-title");
    consentViewTitle.innerText = "Cookies You Accept";

    const consentViewSettings = consentView.querySelector(
        ".isense-cc-settings-dialog"
    );
    consentViewSettings.classList.add("consent-bar-consent-settings");

    const consentViewCloseBtn = consentView.querySelector(
        ".cc-btn-close-settings"
    );
    consentViewCloseBtn.classList.add("consent-bar-consent-close-btn");
    consentViewCloseBtn.addEventListener("click", () => {
        consentBar.classList.remove("consent-bar-hide");
    });

    const consentViewTitles = consentViewSettings.querySelectorAll("label");
    consentViewTitles.forEach((consentTitle) => {
        consentTitle.classList.add("consent-bar-consent-titles");
    });

    const consentViewTexts = consentViewSettings.querySelectorAll(
        ".isense-cc-cookie-category-text"
    );

    consentViewTexts.forEach((consentText) => {
        consentText.classList.add("consent-bar-consent-text");

        const seeMoreBtn = document.createElement("p");
        seeMoreBtn.classList.add("consent-bar-see-more");
        seeMoreBtn.innerText = "[ Read More ]";
        consentText.style.height = "0px";
        consentText.insertAdjacentElement("afterend", seeMoreBtn);

        seeMoreBtn.addEventListener("mouseup", () => {
            // Close all other open sections
            consentViewTexts.forEach((otherText) => {
                if (otherText !== consentText && otherText.style.height !== "0px") {
                    otherText.style.height = "0px";
                    otherText.nextElementSibling.innerText = "[ Read More ]";
                    otherText.nextElementSibling.style.marginTop = "-1rem";
                }
            });

            // Toggle the current section
            const textScrollHeight = consentText.scrollHeight;
            if (consentText.style.height === "0px") {
                consentText.style.height = `${textScrollHeight}px`;
                seeMoreBtn.innerText = "[ Read Less ]";
                seeMoreBtn.style.marginTop = "0";
            } else {
                consentText.style.height = "0px";
                seeMoreBtn.style.marginTop = "-1.5rem";
                seeMoreBtn.innerText = "[ Read More ]";
            }
        });
    });

    const consentViewButtonsCont =
        consentView.querySelector(".cc-compliance");
    consentViewButtonsCont.classList.add("consent-bar-consent-buttons-cont");

    const consentVerification = consentView.querySelector(
        ".cc-consent-verification"
    );
    consentVerification.style.display = "none";

    document
        .querySelector(".consent-bar-consent-settings")
        .style.setProperty("height", "max-content", "important");
})